module.exports = __webpack_public_path__ + "static/media/close.91bf8a44.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/close.png
// module id = 372
// module chunks = 0